import React from 'react';
import { GetCzechSuklRsAtcGroupsQueryResult } from '~/libs/infrastructure/api/availability';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';
import { PaginationPanel } from '~/libs/ui/molecules/PaginationPanel';

import { PerPageSelect } from './PerPageSelect';
import { Row } from './Row';

type AvailabilityGroup = GetCzechSuklRsAtcGroupsQueryResult['items'][number];

export interface AvailabilityListProps {
	data: GetCzechSuklRsAtcGroupsQueryResult | undefined;
	isFetching: boolean;
	isError: boolean;
	dddShareThreshold: number;
	selectable: boolean;
	selectedIds: Set<string>;
	selectionDisabled: boolean;
	onToggleSelect(group: AvailabilityGroup, checked: boolean): void;
	perPage: number;
	onPageChange(page: number): void;
	onPerPageChange(perPage: number): void;
}

export function AvailabilityList({
	data,
	isFetching,
	isError,
	dddShareThreshold,
	selectable,
	selectedIds,
	selectionDisabled,
	onToggleSelect,
	perPage,
	onPageChange,
	onPerPageChange,
}: AvailabilityListProps) {
	if (isError) {
		return <div className='py-10 text-center text-red-600'>Data se nepodařilo načíst. Zkuste to prosím znovu.</div>;
	}

	if (!data && isFetching) {
		return (
			<div className='flex justify-center py-10'>
				<SpinningLoadingIcon />
			</div>
		);
	}

	if (!data) {
		return null;
	}

	if (data.items.length === 0 && !isFetching) {
		return <div className='py-10 text-center text-gray-500'>Nic nenalezeno.</div>;
	}

	return (
		<div className={isFetching ? 'opacity-60 pointer-events-none' : undefined}>
			{data.items.map((group, index) => (
				<div key={group.id} className={index > 0 ? 'pt-4 mt-4 border-t border-gray-300' : undefined}>
					<Row
						group={group}
						dddShareThreshold={dddShareThreshold}
						selectable={selectable}
						selected={selectedIds.has(group.id)}
						selectionDisabled={selectionDisabled}
						onToggleSelect={onToggleSelect}
					/>
				</div>
			))}

			<div className='pt-4 flex flex-wrap items-center justify-between gap-4'>
				<PaginationPanel pagination={data.pagination} onChange={onPageChange} />
				<PerPageSelect value={perPage} onChange={onPerPageChange} />
			</div>
		</div>
	);
}
